export default "__VITE_ASSET__VqpNpZCt__"